// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-f9de4336e7e344ff.js";
if (chunkId === "691") return "js/vendor-super-form-ad9eca33159d4feb.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "b88226ff0b1224db",}[chunkId] + ".chunk.js"
}